var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 761,
    height: 978,
    viewBox: "0 0 761 978",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0548 827.581L690.609 831.897L691.07 789.805L691.778 789.813L692.41 667.325L693.807 539.67L-55.0038 528.023L-55.1813 544.239L-56.6427 677.76L-60.0676 990.687C-60.0752 991.377 -60.0865 992.412 -60.0941 993.102C-60.3962 1020.7 -37.6273 1043.38 -9.30207 1043.69C19.0232 1044 42.2829 1021.83 42.585 994.226C42.5926 993.536 42.6039 992.501 42.6114 991.811L42.9655 991.815L44.0548 827.581ZM589.681 703.121L45.1281 697.161L45.5322 660.245L590.085 666.205L589.681 703.121ZM248.755 81.0509C271.088 78.8799 294.826 77.7594 319.61 78.0307C451.323 79.4723 549.707 117.125 615.116 190.993C670.044 251.978 696.774 333.359 695.663 434.793L694.893 505.176L594.339 504.075L595.079 436.453C595.917 359.86 571.401 302.657 521.543 263.81C475.192 228.107 407.761 209.426 319.245 208.458C293.398 208.175 269.661 209.295 247.321 212.156L248.755 81.0509Z",
    fill: "url(#paint0_linear_32_441)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_441",
    x1: 314.119,
    y1: 1047.23,
    x2: 324.725,
    y2: 78.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 969.202,
    height: 749.7,
    fill: "white",
    transform: "translate(0 969.144) rotate(-89.3729)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.64b8675aad093aac0f1f735baec26742.svg";
export { ForwardRef as ReactComponent };